__turbopack_context__.v({
  "loading_spinner": "gy3r-q_loading_spinner",
  "root": "gy3r-q_root",
  "spinner": "gy3r-q_spinner",
});
